module.exports = __webpack_public_path__ + "images/rating-star-blue-38f74527.svg";